export const getMajorVersion = (): number => {
  const version = process.env.REACT_APP_VERSION || '0.0.0';
  console.log('🔍 Version Debug - REACT_APP_VERSION:', version);
  const majorVersion = parseInt(version.split('.')[0], 10);
  console.log('🔍 Version Debug - Major Version:', majorVersion);
  return isNaN(majorVersion) ? 0 : majorVersion;
}

export const getPathVersion = (): number => {
  const version = process.env.REACT_APP_VERSION || '0.0.0';
  const pathVersion = parseInt(version.split('.')[1], 10);
  return isNaN(pathVersion) ? 0 : pathVersion;
}

export const getMinorVersion = (): number => {
  const version = process.env.REACT_APP_VERSION || '0.0.0';
  const minorVersion = parseInt(version.split('.')[1], 10);
  return isNaN(minorVersion) ? 0 : minorVersion;
}